if (typeof SwatchItem !== 'function') {
    class SwatchItem extends HTMLElement {
        constructor() {
            super();
            this.cache = new Map();
            this.init();
        }

        init() {
            this.fetch = this.getAttribute('fetch');
            this.fetch = new URL(this.fetch, `${window.location.origin}${Shopify.routes.root}`);

            this.value = this.getAttribute('value');

            this.targetContainer = this.closest('.product-item')?.querySelector('[data-js-product-item-image]');
            
            if (!this.fetch || !this.targetContainer) return;
            
            const prefetchEvent = 'ontouchstart' in window ? 'touchstart' : 'mouseenter';
            this.addEventListener(prefetchEvent, () => this.prefetch(), { once: true, passive: true });


            if (this.hasAttribute('checked')) {
                // this.matchB4B();
                this.updateColorLabel();
                this.updateProductCard();
            }
            
            this.addEventListener('click', (e) => {
                e.preventDefault();
                this.updateSwatches();
                this.updateLinks();
                this.fetchProduct();
                this.updateColorLabel();
                this.updateProductCard();
            });
        }

        // matchB4B() {
        //     requestAnimationFrame(() => {
        //         const productItem = this.closest('.product-item[data-b4b-color]');
        //         if (!productItem) return;
                
        //         const targetColor = productItem.getAttribute('data-b4b-color');
        //         const currentColor = this.value;
                
        //         // Early return if already matching or no target color
        //         if (!targetColor || targetColor === currentColor) return;
                
        //         // Find elements
        //         const currentCheckedSwatch = productItem.querySelector('swatch-item[checked]');
        //         const targetSwatch = productItem.querySelector(`swatch-item[value="${CSS.escape(targetColor)}"]`);
        //         const modal = productItem.querySelector('product-modal-toggle');
                
        //         if (!targetSwatch) return;
                
        //         // Update checked states
        //         currentCheckedSwatch?.removeAttribute('checked');
        //         targetSwatch.setAttribute('checked', '');
                
        //         // Move target swatch to first position
        //         const swatchContainer = targetSwatch.parentElement;
        //         if (swatchContainer?.firstElementChild !== targetSwatch) {
        //             swatchContainer.insertBefore(targetSwatch, swatchContainer.firstElementChild);
        //         }
                
        //         // Show swatch and update modal if needed
        //         if (targetSwatch.style.display === 'none') {
        //             targetSwatch.style.display = 'block';
        //         }

        //         console.log(targetSwatch.getAttribute('fetch'));
        //         console.log(modal);
                
        //         if (modal && targetSwatch.hasAttribute('fetch')) {
        //             modal.setAttribute('data-product-url', targetSwatch.getAttribute('fetch'));
        //         }
        //     });
        // }

        updateLinks() {
            const links = this.closest(`.product-item`).querySelectorAll('a');
            const modal = this.closest(`.product-item`).querySelector('product-modal-toggle');
            
            const url = new URL(this.fetch);
            url.searchParams.delete('sections');

            modal.setAttribute('data-product-url', url.toString());
            links.forEach(link => {
                link.setAttribute('href', url);
            });
        }

        updateColorLabel() {
            const colorLabel = this.closest('.product-item').querySelector('[data-js-color-label]');
            if (colorLabel) {
                colorLabel.textContent = this.value;
            }
        }

        updateProductCard() {
            const productCard = this.closest('.product-item');
            if (productCard) {
                productCard.setAttribute('color', this.value);
            }
        }

        updateSwatches() {
            if (this === this.closest('swatch-item[checked]')) return;
            const swatchItems = this.closest('.product-item-swatches').querySelectorAll('swatch-item');
            swatchItems.forEach(item => {
                item.removeAttribute('checked');
            });

            this.setAttribute('checked', '');
        }

        async prefetch() {
            if (this.cache.has(this.fetch)) return;
            
            try {
                const response = await fetch(this.fetch);
                const text = await response.text();
                const content = this.parseHTML(text);
                this.cache.set(this.fetch, content);
            } catch (e) {
                // Silent fail
            }
        }

        async fetchProduct() {
            if (this.cache.has(this.fetch)) {
                this.targetContainer.innerHTML = this.cache.get(this.fetch);
                return;
            }

            try {
                const response = await fetch(this.fetch);
                const text = await response.text();
                const content = this.parseHTML(text);
                
                this.cache.set(this.fetch, content);
                this.targetContainer.innerHTML = content;
            } catch (error) {
                console.error('Swatch fetch failed:', error);
            }
        }

        parseHTML(text) {
            // Try JSON first, fallback to HTML
            try {
                const json = JSON.parse(text);
                text = json['helper-variant-image'] || text;
            } catch (e) {}

            const doc = new DOMParser().parseFromString(text, 'text/html');
            const section = doc.querySelector('.shopify-section');
            return section?.innerHTML || text;
        }
    }

    customElements.define('swatch-item', SwatchItem);
}


if (typeof SwatchContainer !== 'function') {
    class SwatchContainer extends HTMLElement {
        constructor() {
            super();
            this.swatches = this.querySelectorAll('swatch-item');
            this.limitSwatches();
            window.addEventListener('resize', () => debounce(this.limitSwatches(), 300));
        }

        limitSwatches() {
            const isMobile = window.innerWidth <= 768;
            const maxSwatches = isMobile ? 5 : 8 
            this.swatches.forEach((swatch, index) => {
                if (index >= maxSwatches) {
                    swatch.style.display = 'none';
                } else {
                    swatch.style.display = 'block';
                }
            })  
            if (this.swatches.length > maxSwatches) {
                const existing = this.querySelector('.swatch-more');
                if (!existing) {
                    const remaining = this.swatches.length - maxSwatches;
                    const moreText = document.createElement('span');
                    moreText.className = 'swatch-more';
                    moreText.textContent = `+ ${remaining}`;
                    this.appendChild(moreText);
                } else {
                    const remaining = this.swatches.length - maxSwatches;
                    existing.textContent = `+ ${remaining}`;
                }
            }
        }
    }

    customElements.define('swatch-container', SwatchContainer);
}